// REACT_APP_DEV_URL: https://test.api.navbat.tj/api/v1
// REACT_APP_PROD_URL: https://api.navbat.tj/api/v1
// REACT_APP_CURRENT_URL: https://test.api.navbat.tj/api/v1
// REACT_APP_PROD_URL: https://api.navbat.tj/api/v1

// Тестовые ключи

// export const currentUrl: string = `https://test2.api.navbat.tj/api/v1`
// export const hashUrl: string = `https://test2.api.navbat.tj/api/`
// export const deepUrl:string = `https://client2.navbat.tj`
// export const navbatKey: string = `kEX9oFXFkv0GGiOdPO55xgcZ4pAErUzNOoej3kwr` 

// Продакшн ключи

export const currentUrl: string = `https://api.navbat.tj/api/v1`
export const hashUrl: string = `https://api.navbat.tj/api/`
export const deepUrl:string = `https://navbat.tj`
export const navbatKey: string = `YpCCMBnHLsK0bz6agS7lEn4UMfKQTA8jOJjNLk38` 

